import React from 'react';
import Button from '../../../UI/Button/Button';
import CountryById from "../CountrySelect/CountryById";

const MobileAddressesList = ({ addresses, setEditAddressId, removeAddress }) => {
    return (
        <>
            {addresses.map(({ id, firstname, lastname, street, city, country_id, country_code, postcode, telephone }) => (
                <div className="mobile-address" key={id}>
                    <p>
                        <span className="mobile-address__rows">Ime:</span>
                        {firstname}
                    </p>
                    <p>
                        <span className="mobile-address__rows">Prezime:</span>
                        {lastname}
                    </p>
                    <p>
                        <span className="mobile-address__rows">Adresa ulice:</span>
                        {street[0]}
                    </p>
                    <p>
                        <span className="mobile-address__rows">Grad:</span>
                        {city}
                    </p>
                    <p>
                        <span className="mobile-address__rows">Država:</span>
                        <CountryById id={country_code || country_id} mobile />
                    </p>
                    <p>
                        <span className="mobile-address__rows">Županija:</span>
                    </p>
                    <p>
                        <span className="mobile-address__rows">Poštanski broj:</span>
                        {postcode}
                    </p>
                    <p>
                        <span className="mobile-address__rows">Telefon:</span>
                        {telephone}
                    </p>
                    <p>
                        <span className="addresses-rows">Radnje:</span>
                        <Button text="Uredite" type="button" trait="profile" onClick={() => setEditAddressId(id)} />
                        <Button text="Uklonite" type="button" trait="profile" onClick={() => removeAddress({ variables: { id: +id } })} />
                    </p>
                </div>
            ))}
        </>
    );
};

export default MobileAddressesList;
